"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (functions) {
    return functions.reduce(function (accumulatedFn, fn) { return function (arg) { return fn(accumulatedFn(arg)); }; });
});
